import { field, relation, text, writer } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { ADDRESS_SCHEMA } from '../schema';

export default class Address extends Model {
    static table = ADDRESS_SCHEMA

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
    }

    @text('instructions') instructions;
    @text('shop_number') shop_number;
    @field('longitude') longitude;
    @text('shop_name') shop_name;
    @text('province') province;
    @text('building') building;
    @field('latitude') latitude;
    @text('address') address;
    @text('floor') floor;
    @text('area') area;
    @text('city') city;

    @relation('user', 'user_id') user;

    @writer async updateDetails(data) {
        return await this.update(address => {
            address.instructions = data.instructions;
            address.shop_number = data.shop_number;
            address.longitude = data.longitude;
            address.shop_name = data.shop_name;
            address.province = data.province;
            address.latitude = data.latitude;
            address.building = data.building;
            address.address = data.address;
            address.floor = data.floor;
            address.city = data.city;
            address.area = data.area;
        });
    };

    @writer async updateUserDetails(data) {
        return await this.update(address => {
            address.province = data.province
            address.address = data.address
            address.city = data.city
            address.area = data.area
        });
    };

    @writer async markAsDeleted() {
        await super.markAsDeleted();
    };
};